document.addEventListener('DOMContentLoaded', function() {
    /** @type {HTMLElement | null} */
    const postBody = document.querySelector('.post_body');
    if (!postBody) return;

    // Prevent duplicate initialization if this script is included more than once
    if (postBody.dataset.blogPostH2BlocksInitialized === 'true') return;
    postBody.dataset.blogPostH2BlocksInitialized = 'true';

    // Obtener configuraciones de las secciones desde data attributes del post_body
    const sectionConfigs = {
        executive_summary: {
            text: postBody.dataset.executiveSummaryText || '',
            backgroundColor: postBody.dataset.executiveSummaryBg || '#FAEAB4',
            sectionId: postBody.dataset.executiveSummaryId || 'executive-summary'
        },
        post_review: {
            text: postBody.dataset.postReviewText || '“Absolutely love this product. Can’t imagine life without it!” ',
            image: postBody.dataset.postReviewImage || '/cdn/shop/files/image_5153.png?v=1758041793',
            imageMobile: postBody.dataset.postReviewImageMobile || '/cdn/shop/files/image_5153_1.png?v=1758125484',
            rating: parseInt(postBody.dataset.postReviewRating || '5', 10) || 5,
            author: postBody.dataset.postReviewAuthor || '', 
            sectionId: postBody.dataset.postReviewId || 'post-review'
        },
        post_newsletter: {
            text: postBody.dataset.postNewsletterText || 'Get the latest on all things Mānuka and be the first for exclusive offers.',
            backgroundColor: postBody.dataset.postNewsletterBg || '#ffffff',
            sectionId: postBody.dataset.postNewsletterId || 'post-newsletter'
        },
        post_take_quiz: {
            text: postBody.dataset.postTakeQuizText || 'Let us help you find your perfect match!',
            image: (
                !postBody.dataset.postTakeQuizImage ||
                postBody.dataset.postTakeQuizImage.includes('Liquid error')
            )
                ? '/cdn/shop/files/Rectangle_17567.png?v=1758051285'
                : postBody.dataset.postTakeQuizImage,
            btnText: postBody.dataset.postTakeQuizBtnText || 'TAKE THE QUIZ',
            btnLink: postBody.dataset.postTakeQuizBtnLink || '/',
            backgroundColor: postBody.dataset.postTakeQuizBg || '#F6BE00',
            sectionId: postBody.dataset.postTakeQuizId || 'post-take-quiz'
        }
    };

    // Función para crear la sección executive_summary
    function createExecutiveSummary(config) {
        if (config.text) {
            // Si hay texto en el metafield, usarlo directamente
            const section = document.createElement('div');
            section.className = 'summary post_section';
            section.id = config.sectionId;
            section.style.backgroundColor = config.backgroundColor;
            
            section.innerHTML = `
                <div class="summary_text">
                    ${config.text}
                </div>
            `;
            
            return section;
        }

        // Si no hay texto en el metafield, buscar en el contenido real
        const section = document.createElement('div');
        section.className = 'summary post_section';
        section.id = config.sectionId;
        section.style.backgroundColor = config.backgroundColor;

        const postBody = document.querySelector('.post_body');
        if (postBody) {
            // Buscar el primer elemento que contenga "Executive Summary"
            let foundIdx = -1;
            let nodes = Array.from(postBody.childNodes);
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (
                    node.nodeType === 1 &&
                    node.textContent &&
                    node.textContent.trim().toLowerCase().includes('executive summary')
                ) {
                    foundIdx = i;
                    break;
                }
            }
            if (foundIdx !== -1) {
                // Recopilar nodos a mover (desde foundIdx hasta antes del siguiente h2)
                const toMove = [];
                for (let i = foundIdx; i < nodes.length; i++) {
                    const node = nodes[i];
                    if (
                        node.nodeType === 1 &&
                        node.tagName &&
                        node.tagName.toLowerCase() === 'h2'
                    ) {
                        break;
                    }
                    toMove.push(node);
                }
                // Mover los nodos al summary
                toMove.forEach(node => section.appendChild(node));
            }
        }

        if (!section.hasChildNodes()) return null;
        return section;
    }

    // Función para crear la sección post_review
    function createPostReview(config) {
        if (!config.text) return null;
        
        const section = document.createElement('div');
        section.className = 'post_review post_section';
        section.id = config.sectionId;
        
        let starsHtml = '';
        for (let i = 0; i < config.rating; i++) {
            starsHtml += `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
            <path d="M12.0025 0.351562L15.5292 7.33866L23.4153 8.45909L17.7088 13.8978L19.056 21.5773L12.0025 17.9516L4.9491 21.5773L6.29618 13.8978L0.589844 8.45909L8.47581 7.33866L12.0025 0.351562Z" fill="#F6BE00"/>
            </svg>`;
        }
        
        section.innerHTML = `
            <div class="post_review_image">
                ${config.image ? `<img class="desktop" src="${config.image}" alt="">` : ''}
                ${config.imageMobile ? `<img class="mobile" src="${config.imageMobile}" alt="">` : ''}
            </div>
            <div class="post_review_rating">
                ${starsHtml}
            </div>
            <div class="post_review_text">
            <p>
                <em>${config.text}</em>
            </p>
            </div>
            <div class="post_review_author">
                ${config.author}
            </div>
        `;
        
        return section;
    }

    // Función para crear la sección post_newsletter
    function createPostNewsletter(config) {
        if (!config.text) return null;
        
        const section = document.createElement('div');
        section.className = 'post_newsletter post_section';
        section.id = config.sectionId;
        section.style.backgroundColor = config.backgroundColor;
        
        section.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                <path d="M18.3022 7.8092C18.1948 7.70186 18.0338 7.59452 18.0338 7.43351C18.0338 7.32617 18.0875 7.27249 18.1412 7.16515C18.5169 6.52111 18.3558 5.60871 17.7118 5.17935C17.2824 4.911 16.7457 4.85733 16.2627 4.96467C15.7797 5.07201 15.3503 5.28669 14.9209 5.55504C14.5452 5.82339 14.1159 6.03808 13.7402 6.3601C13.7402 6.14542 13.7402 5.93074 13.5792 5.76972C13.6865 5.66238 13.7939 5.55504 13.9012 5.50137C14.5452 4.911 15.1893 4.26695 15.565 3.4619C15.726 3.03254 15.8333 2.5495 15.6187 2.12014C15.2966 1.4761 14.3842 1.42242 13.6865 1.58344C13.5255 1.63711 13.3645 1.63711 13.2572 1.52977C13.2035 1.4761 13.1498 1.36875 13.1498 1.31508C12.8815 0.617369 12.0764 0.188007 11.325 0.402688C10.842 0.563699 10.4663 0.939392 10.2516 1.36875C10.0369 1.79812 9.92959 2.33482 9.87593 2.81785C9.82225 3.08621 9.82225 3.30089 9.82225 3.56924C9.66124 3.4619 9.44656 3.40823 9.28555 3.4619H9.23188C9.17821 2.60317 9.07087 1.74445 8.64151 0.993062C8.42683 0.563699 8.1048 0.188007 7.62177 0.134336C6.92406 -0.0266749 6.28001 0.617369 6.01166 1.31508C5.95799 1.42242 5.90432 1.58344 5.74331 1.63711C5.63597 1.63711 5.5823 1.63711 5.47496 1.58344C4.77724 1.31508 3.91851 1.74445 3.65016 2.44216C3.48915 2.87152 3.54282 3.40823 3.7575 3.83759C3.97219 4.26695 4.29421 4.64265 4.61623 5.01834C5.09926 5.55504 5.63597 6.03808 6.22634 6.46744C6.22634 6.46744 6.22634 6.46744 6.28001 6.52111C6.01166 6.41377 5.74331 6.41377 5.47496 6.52111C5.26027 6.3601 5.04559 6.19909 4.83091 6.03808C4.07953 5.55504 3.32814 5.07201 2.46941 4.911C1.98638 4.80366 1.44968 4.80366 1.12766 5.12568C0.590952 5.60871 0.698293 6.46744 1.02032 7.11148C1.07399 7.27249 1.12766 7.43351 1.07399 7.59452C1.02032 7.64819 0.966645 7.70186 0.859304 7.75553C0.21526 8.13122 0.000578299 9.09729 0.376271 9.74133C0.644623 10.1707 1.07399 10.439 1.55702 10.5464C2.04005 10.6537 2.52309 10.6537 3.05979 10.6001C3.48915 10.5464 3.86484 10.4927 4.29421 10.3854V10.439C4.29421 10.6001 4.40155 10.7611 4.45522 10.9221C4.29421 10.9757 4.07953 11.0294 3.91851 11.0831C3.05979 11.3514 2.20106 11.6735 1.55702 12.2102C1.235 12.5322 0.912975 12.9079 0.912975 13.3909C0.912975 14.0886 1.71803 14.5717 2.41574 14.7327C2.57676 14.7863 2.73777 14.7863 2.79144 14.9474C2.84511 15.0547 2.79144 15.1084 2.79144 15.2157C2.6841 15.9671 3.27447 16.7185 4.02586 16.8258C4.50889 16.8795 4.99192 16.7185 5.42129 16.3965C5.79698 16.0744 6.119 15.6987 6.38735 15.2694C6.60203 14.8937 6.81671 14.5717 7.0314 14.196C7.08507 14.4107 7.19241 14.6253 7.35342 14.7863C7.35342 14.84 7.29975 14.8937 7.29975 14.9474C6.97773 15.7524 6.6557 16.6111 6.70937 17.5235C6.70937 18.0066 6.87039 18.4896 7.24608 18.758C7.83645 19.1873 8.64151 18.8653 9.23188 18.4359C9.33922 18.3286 9.50023 18.2212 9.66124 18.2749C9.76858 18.2749 9.82225 18.3823 9.87593 18.4359C10.4126 18.9726 11.3787 18.9726 11.9154 18.4896C12.2911 18.1676 12.4521 17.6309 12.4521 17.1478C12.4521 16.6648 12.3448 16.1818 12.1838 15.6987C12.0764 15.3767 11.9691 15.0547 11.8081 14.7327C11.9691 14.5717 12.0764 14.4107 12.1301 14.196C12.2374 14.357 12.3448 14.5717 12.3984 14.7327C12.8278 15.4841 13.3108 16.2891 14.0622 16.7722C14.4379 17.0405 14.9209 17.2552 15.3503 17.1478C16.048 16.9868 16.3164 16.1281 16.3164 15.3767C16.3164 15.2157 16.3164 15.0547 16.4237 14.9474C16.4774 14.8937 16.5847 14.8937 16.6921 14.8937C17.4434 14.7863 18.0338 14.0886 17.9802 13.3372C17.9265 12.8542 17.6581 12.3712 17.2824 12.1028C16.9067 11.7808 16.4237 11.5661 15.9943 11.4051C15.565 11.2441 15.1893 11.1368 14.7599 11.0294C14.9746 10.9221 15.1893 10.7611 15.2966 10.6001C15.3503 10.6001 15.404 10.6001 15.4576 10.6001C16.3164 10.7611 17.2288 10.8147 18.0875 10.6001C18.5169 10.4927 18.9999 10.2244 19.1609 9.795C19.3756 9.04362 18.8925 8.29223 18.3022 7.8092Z" fill="#F6BE00"/>
                    </svg>
                </div>
                <p class="post_newsletter_text">
                    ${config.text}
                </p>
                <div class="klaviyo-form-Rr3t6B newsletter_form"></div>
        `;
        
        return section;
    }

    // Función para crear la sección post_take_quiz
    function createPostTakeQuiz(config) {
        if (!config.text) return null;
        
        const section = document.createElement('div');
        section.className = 'post_take_quiz post_section';
        section.id = config.sectionId;
        section.style.backgroundColor = config.backgroundColor;

        console.log('image', config.image);
        
        
        section.innerHTML = `
            <div class="post_take_quiz_image">
                ${config.image ? `<img src="${config.image}" alt="">` : ''}
            </div>
            <div class="ctn_txt">
                <p class="post_take_quiz_text">
                    ${config.text}
                </p>
                ${config.btnLink ? `
                    <a href="${config.btnLink}" class="post_take_quiz_btn btn-primary">
                        ${config.btnText}
                    </a>
                ` : ''}
            </div>
        `;
        
        return section;
    }

    // Nueva función: crear el contenedor de conclusión si no existe
    // y mover desde "Conclusion/Conclusión" hasta el final dentro de ese contenedor
    function fillPostConclusionFromContent() {
        const postBody = document.querySelector('.post_body');
        if (!postBody) return;

        let container = postBody.querySelector('.post_conclusion.post_section');

        // Si existe y ya tiene contenido visible, no hacer nada
        if (container && (container.textContent || '').trim().length > 0) return;

        // Buscar el primer nodo cuyo texto contenga "conclusion" o "conclusión"
        const nodes = Array.from(postBody.childNodes);
        let startIndex = -1;

        // Si ya existe contenedor, buscamos solo antes de él
        const containerIndex = container ? nodes.indexOf(container) : -1;
        const lastIndexToScan = container && containerIndex !== -1 ? containerIndex : nodes.length;

        for (let i = 0; i < lastIndexToScan; i++) {
            const node = nodes[i];
            if (node.nodeType === 1) { // ELEMENT_NODE
                const text = (node.textContent || '').trim().toLowerCase();
                if (text.includes('conclusion') || text.includes('conclusión')) {
                    startIndex = i;
                    break;
                }
            }
        }

        // Si no hay marcador de conclusión:
        if (startIndex === -1) {
            // Si existe contenedor vacío pre-renderizado, eliminarlo para que no se vea vacío
            if (container && (container.textContent || '').trim().length === 0) {
                container.remove();
            }
            return;
        }

        // Crear contenedor si no existe
        if (!container) {
            container = document.createElement('div');
            container.className = 'post_conclusion post_section';
            container.id = 'post-conclusion';
            container.style.backgroundColor = '#FAEAB4';
            postBody.appendChild(container);
        }

        // Determinar fin de movimiento: hasta antes del contenedor (si existía) o hasta el final
        const endIndex = containerIndex !== -1 ? containerIndex : nodes.length;

        // Mover desde el índice de inicio hasta el final determinado
        const toMove = nodes.slice(startIndex, endIndex);
        toMove.forEach(n => container.appendChild(n));
    }
    
    // Array con las funciones de creación de secciones en orden
    const sectionCreators = [
        () => createExecutiveSummary(sectionConfigs.executive_summary),
        () => postBody.dataset.postReviewBlockExists === 'true' ? createPostReview(sectionConfigs.post_review) : null,
        () => {
            // Crear contenedor para newsletter y quiz juntos
            const container = document.createElement('div');
            const newsletter = createPostNewsletter(sectionConfigs.post_newsletter);
            const quiz = createPostTakeQuiz(sectionConfigs.post_take_quiz);
            
            if (newsletter) container.appendChild(newsletter);
            if (quiz) container.appendChild(quiz);
            
            return container.hasChildNodes() ? container : null;
        }
    ];

    // Insertar el executive summary (summary post_section) siempre primero al inicio del contenido
    const executiveSummarySection = sectionCreators[0]();
    if (executiveSummarySection) {
        postBody.insertBefore(executiveSummarySection, postBody.firstChild);
    }

    // Buscar todos los H2 dentro del article content
    const h2Elements = postBody.querySelectorAll('h2');

    // Insertar el resto de secciones antes de su H2 correspondiente (post_review antes del 2º H2, newsletter+quiz antes del 3º H2)
    h2Elements.forEach((h2, index) => {
        if (index >= 1 && index < sectionCreators.length) {
            const section = sectionCreators[index]();
            if (section) {
                h2.parentNode.insertBefore(section, h2);
            }
        }
    });

    // NUEVO: Completar/crear la conclusión desde el contenido si el bloque no existe o está vacío
    fillPostConclusionFromContent();

    // Generar Table of Contents automáticamente
    generateTableOfContents();
});

// Variable global para controlar el estado de navegación por click
let isManualNavigation = false;
let navigationTimeout = null;

// Función para generar Table of Contents basado en H2s
function generateTableOfContents() {
    const postBody = document.querySelector('.post_body');
    if (!postBody) return;

    const tocListMobile = document.getElementById('toc-list');
    const tocListDesktop = document.getElementById('toc-list-desktop');
    
    if (!tocListMobile || !tocListDesktop) return;

    // Limpiar listas existentes
    tocListMobile.innerHTML = '';
    tocListDesktop.innerHTML = '';

    // Obtener todas las secciones que deben estar en el TOC
    const sections = [];
    const sectionElements = [];

    const usedTexts = new Set();

    function normalizeTocText(text) {
        // Normalize to dedupe headings even if they contain punctuation like ':'
        // or formatting changes (e.g. <strong> inside the heading).
        return (text || '')
            .replace(/\u00A0/g, ' ')
            .replace(/[\u200B-\u200D\uFEFF]/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }
    
    // 1. Executive Summary (siempre primero)
    const executiveSummary = document.querySelector('.summary.post_section');
    if (executiveSummary) {
        const text = 'Executive Summary';
        const key = normalizeTocText(text);
        if (!usedTexts.has(key)) {
            usedTexts.add(key);
            sections.push({
                element: executiveSummary,
                text: text,
                id: executiveSummary.id || 'executive-summary'
            });
            sectionElements.push(executiveSummary);
        }
    }
    
    // 2. H2s del contenido
    const h2Elements = postBody.querySelectorAll('h2');
    h2Elements.forEach((h2, index) => {
        // OMITIR H2 que estén dentro de la conclusión para evitar duplicados
        if (h2.closest('.post_conclusion')) return;

        // OMITIR H2 dentro de secciones inyectadas (metafields pueden traer <h2> y duplicar el TOC)
        if (h2.closest('.post_section')) return;

        const text = h2.textContent.trim();
        if (!text) return;

        const key = normalizeTocText(text);
        if (!key || usedTexts.has(key)) return;
        usedTexts.add(key);

        // Crear ID único para el H2
        let slug = createSlug(text);
        if (!slug) slug = `section-${index + 1}`;

        // Asegurar que el ID sea único
        let finalId = slug;
        let counter = 1;
        while (document.getElementById(finalId)) {
            finalId = `${slug}-${counter}`;
            counter++;
        }

        // Asignar ID al H2
        h2.id = finalId;

        sections.push({
            element: h2,
            text: text,
            id: finalId
        });
        sectionElements.push(h2);
    });
    
    // 3. Post Conclusion (siempre último)
    const postConclusion = document.querySelector('.post_conclusion.post_section');
    if (postConclusion) {
        const text = 'Conclusion';
        const key = normalizeTocText(text);
        if (!usedTexts.has(key)) {
            usedTexts.add(key);
            sections.push({
                element: postConclusion,
                text: text,
                id: postConclusion.id || 'post-conclusion'
            });
            sectionElements.push(postConclusion);
        }
    }

    // Función para crear slug único
    function createSlug(text) {
        return text.toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '') // Remover caracteres especiales
            .replace(/[\s_-]+/g, '-') // Reemplazar espacios y guiones con un solo guión
            .replace(/^-+|-+$/g, ''); // Remover guiones del inicio y final
    }

    // Mapa para relacionar elementos con sus items del TOC
    const tocItemsMap = new Map();

    // Crear elementos del TOC para ambas listas
    sections.forEach((section, index) => {
        const createTocItem = (listType) => {
            const li = document.createElement('li');
            // Marcar Executive Summary como activo por defecto
            if (index === 0) li.classList.add('active');

            const a = document.createElement('a');
            a.href = `#${section.id}`;
            a.innerHTML = `
                <span class="toc-flower">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                        <path d="M18.3022 7.8092C18.1948 7.70186 18.0338 7.59452 18.0338 7.43351C18.0338 7.32617 18.0875 7.27249 18.1412 7.16515C18.5169 6.52111 18.3558 5.60871 17.7118 5.17935C17.2824 4.911 16.7457 4.85733 16.2627 4.96467C15.7797 5.07201 15.3503 5.28669 14.9209 5.55504C14.5452 5.82339 14.1159 6.03808 13.7402 6.3601C13.7402 6.14542 13.7402 5.93074 13.5792 5.76972C13.6865 5.66238 13.7939 5.55504 13.9012 5.50137C14.5452 4.911 15.1893 4.26695 15.565 3.4619C15.726 3.03254 15.8333 2.5495 15.6187 2.12014C15.2966 1.4761 14.3842 1.42242 13.6865 1.58344C13.5255 1.63711 13.3645 1.63711 13.2572 1.52977C13.2035 1.4761 13.1498 1.36875 13.1498 1.31508C12.8815 0.617369 12.0764 0.188007 11.325 0.402688C10.842 0.563699 10.4663 0.939392 10.2516 1.36875C10.0369 1.79812 9.92959 2.33482 9.87593 2.81785C9.82225 3.08621 9.82225 3.30089 9.82225 3.56924C9.66124 3.4619 9.44656 3.40823 9.28555 3.4619H9.23188C9.17821 2.60317 9.07087 1.74445 8.64151 0.993062C8.42683 0.563699 8.1048 0.188007 7.62177 0.134336C6.92406 -0.0266749 6.28001 0.617369 6.01166 1.31508C5.95799 1.42242 5.90432 1.58344 5.74331 1.63711C5.63597 1.63711 5.5823 1.63711 5.47496 1.58344C4.77724 1.31508 3.91851 1.74445 3.65016 2.44216C3.48915 2.87152 3.54282 3.40823 3.7575 3.83759C3.97219 4.26695 4.29421 4.64265 4.61623 5.01834C5.09926 5.55504 5.63597 6.03808 6.22634 6.46744C6.22634 6.46744 6.22634 6.46744 6.28001 6.52111C6.01166 6.41377 5.74331 6.41377 5.47496 6.52111C5.26027 6.3601 5.04559 6.19909 4.83091 6.03808C4.07953 5.55504 3.32814 5.07201 2.46941 4.911C1.98638 4.80366 1.44968 4.80366 1.12766 5.12568C0.590952 5.60871 0.698293 6.46744 1.02032 7.11148C1.07399 7.27249 1.12766 7.43351 1.07399 7.59452C1.02032 7.64819 0.966645 7.70186 0.859304 7.75553C0.21526 8.13122 0.000578299 9.09729 0.376271 9.74133C0.644623 10.1707 1.07399 10.439 1.55702 10.5464C2.04005 10.6537 2.52309 10.6537 3.05979 10.6001C3.48915 10.5464 3.86484 10.4927 4.29421 10.3854V10.439C4.29421 10.6001 4.40155 10.7611 4.45522 10.9221C4.29421 10.9757 4.07953 11.0294 3.91851 11.0831C3.05979 11.3514 2.20106 11.6735 1.55702 12.2102C1.235 12.5322 0.912975 12.9079 0.912975 13.3909C0.912975 14.0886 1.71803 14.5717 2.41574 14.7327C2.57676 14.7863 2.73777 14.7863 2.79144 14.9474C2.84511 15.0547 2.79144 15.1084 2.79144 15.2157C2.6841 15.9671 3.27447 16.7185 4.02586 16.8258C4.50889 16.8795 4.99192 16.7185 5.42129 16.3965C5.79698 16.0744 6.119 15.6987 6.38735 15.2694C6.60203 14.8937 6.81671 14.5717 7.0314 14.196C7.08507 14.4107 7.19241 14.6253 7.35342 14.7863C7.35342 14.84 7.29975 14.8937 7.29975 14.9474C6.97773 15.7524 6.6557 16.6111 6.70937 17.5235C6.70937 18.0066 6.87039 18.4896 7.24608 18.758C7.83645 19.1873 8.64151 18.8653 9.23188 18.4359C9.33922 18.3286 9.50023 18.2212 9.66124 18.2749C9.76858 18.2749 9.82225 18.3823 9.87593 18.4359C10.4126 18.9726 11.3787 18.9726 11.9154 18.4896C12.2911 18.1676 12.4521 17.6309 12.4521 17.1478C12.4521 16.6648 12.3448 16.1818 12.1838 15.6987C12.0764 15.3767 11.9691 15.0547 11.8081 14.7327C11.9691 14.5717 12.0764 14.4107 12.1301 14.196C12.2374 14.357 12.3448 14.5717 12.3984 14.7327C12.8278 15.4841 13.3108 16.2891 14.0622 16.7722C14.4379 17.0405 14.9209 17.2552 15.3503 17.1478C16.048 16.9868 16.3164 16.1281 16.3164 15.3767C16.3164 15.2157 16.3164 15.0547 16.4237 14.9474C16.4774 14.8937 16.5847 14.8937 16.6921 14.8937C17.4434 14.7863 18.0338 14.0886 17.9802 13.3372C17.9265 12.8542 17.6581 12.3712 17.2824 12.1028C16.9067 11.7808 16.4237 11.5661 15.9943 11.4051C15.565 11.2441 15.1893 11.1368 14.7599 11.0294C14.9746 10.9221 15.1893 10.7611 15.2966 10.6001C15.3503 10.6001 15.404 10.6001 15.4576 10.6001C16.3164 10.7611 17.2288 10.8147 18.0875 10.6001C18.5169 10.4927 18.9999 10.2244 19.1609 9.795C19.3756 9.04362 18.8925 8.29223 18.3022 7.8092Z" fill="#F6BE00"/>
                    </svg>
                </span>
                ${section.text}
            `;

            // Agregar event listener para smooth scroll
            a.addEventListener('click', function(e) {
                e.preventDefault();
                const targetElement = document.getElementById(section.id);
                if (targetElement) {
                    // Marcar que estamos en navegación manual
                    isManualNavigation = true;
                    
                    // Limpiar timeout anterior si existe
                    if (navigationTimeout) {
                        clearTimeout(navigationTimeout);
                    }
                    
                    // Remover clase active de todos los elementos
                    document.querySelectorAll('.post_tb_list li').forEach(li => li.classList.remove('active'));
                    // Agregar clase active al elemento clickeado
                    li.classList.add('active');
                    
                    // Smooth scroll
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    
                    // Después de 1 segundo, permitir que el Intersection Observer tome el control nuevamente
                    navigationTimeout = setTimeout(() => {
                        isManualNavigation = false;
                    }, 1000);
                }
            });

            li.appendChild(a);
            
            // Guardar referencia del item del TOC en el mapa
            if (!tocItemsMap.has(section.id)) {
                tocItemsMap.set(section.id, []);
            }
            tocItemsMap.get(section.id).push({
                li: li,
                listType: listType
            });
            
            return li;
        };

        // Agregar a ambas listas
        tocListMobile.appendChild(createTocItem('mobile'));
        tocListDesktop.appendChild(createTocItem('desktop'));
    });

    // Configurar Intersection Observer para detectar secciones en viewport
    setupIntersectionObserver(sectionElements, tocItemsMap);
}

// Función para configurar Intersection Observer
function setupIntersectionObserver(sectionElements, tocItemsMap) {
    const options = {
        root: null,
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
    };

    let hasScrolled = false;

    const observer = new IntersectionObserver((entries) => {
        // Si estamos en navegación manual, ignorar el Intersection Observer
        if (isManualNavigation) return;
        
        let foundActive = false;
        
        entries.forEach(entry => {
            const sectionId = entry.target.id;
            const tocItems = tocItemsMap.get(sectionId);
            
            if (tocItems && entry.isIntersecting && !foundActive) {
                // Remover active de todos los items
                document.querySelectorAll('.post_tb_list li').forEach(li => {
                    li.classList.remove('active');
                });
                
                // Agregar active a los items correspondientes
                tocItems.forEach(item => {
                    item.li.classList.add('active');
                });
                
                foundActive = true;
                hasScrolled = true; // El usuario ha hecho scroll hasta alguna sección
            }
        });

        // Si no se encontró ninguna sección activa Y el usuario no ha hecho scroll significativo
        // mantener el executive summary activo
        if (!foundActive && !hasScrolled && window.scrollY < 300 && !isManualNavigation) {
            const firstItems = tocItemsMap.get(sectionElements[0].id);
            if (firstItems) {
                // Solo activar si no hay otro activo
                const hasActive = document.querySelector('.post_tb_list li.active');
                if (!hasActive) {
                    document.querySelectorAll('.post_tb_list li').forEach(li => {
                        li.classList.remove('active');
                    });
                    firstItems.forEach(item => {
                        item.li.classList.add('active');
                    });
                }
            }
        }
    }, options);

    // Observar todas las secciones
    sectionElements.forEach(section => {
        if (section.id) {
            observer.observe(section);
        }
    });

    // Detectar cuando el usuario hace scroll para cambiar el comportamiento
    let scrollTimer;
    window.addEventListener('scroll', () => {
        if (!hasScrolled && window.scrollY > 100) {
            hasScrolled = true;
        }
        
        // Limpiar timer anterior
        clearTimeout(scrollTimer);
        // Establecer nuevo timer para verificar el estado después de que el scroll se detenga
        scrollTimer = setTimeout(() => {
            // Si el usuario se desplazó hacia arriba cerca del top, reactivar el executive summary
            if (window.scrollY < 50) {
                hasScrolled = false;
                const firstItems = tocItemsMap.get(sectionElements[0].id);
                if (firstItems) {
                    document.querySelectorAll('.post_tb_list li').forEach(li => {
                        li.classList.remove('active');
                    });
                    firstItems.forEach(item => {
                        item.li.classList.add('active');
                    });
                }
            }
        }, 150);
    });
}